
export const capitalizeFirst = (text) => {
    return text.length > 0 ? text.charAt(0).toUpperCase() + text.slice(1) : text
  };

// Haversine formula to compute distance between two lat/lon points
export function haversineDistance(lat1, lon1, lat2, lon2) {
  // Earth's radius in km
  const R = 6371; 
  const dLat = (lat2 - lat1) * (Math.PI / 180);
  const dLon = (lon2 - lon1) * (Math.PI / 180);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1 * Math.PI / 180) *
    Math.cos(lat2 * Math.PI / 180) *
    Math.sin(dLon / 2) *
    Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}